export default __webpack_public_path__ + "assets/antonello-component.19c59a01.svg";